import React from 'react'

import useInterfaceLocale from '../../modules/locale/useInterfaceLocale'

import style from './style.module.scss'
import useTheme from '@aytm/app/swidget/base/modules/theme/useTheme'
import { SurveyMode } from '@aytm/app/swidget/base/actions/types'

export interface INavigationPanelPoweredByProps {
  domain: string
  mode: SurveyMode
}

const NavigationPanelPoweredBy = React.memo<INavigationPanelPoweredByProps>(
  ({ domain, mode }) => {
    const theme = useTheme()
    const { t } = useInterfaceLocale()

    return (
      <>
        {theme.style.hidePoweredBy || mode == SurveyMode.XRAYS ? null : (
          <span className={style.NavigationPanelContentPoweredBy} data-testid="SW-PoweredBy">
            {t('preview', 'texts', 'poweredBy')}
            <a
              className={style.NavigationPanelHref}
              style={{ color: theme.style.accentColor }}
              href={domain}
              target="_blank"
              rel="noreferrer"
              data-testid="SW-PoweredBy-Link"
            >
              aytm
            </a>
          </span>
        )}
      </>
    )
  },
  (prevProps, nextProps) => prevProps.mode === nextProps.mode
)

NavigationPanelPoweredBy.displayName = 'NavigationPanelPoweredBy'

export default NavigationPanelPoweredBy
